import { Button } from '@spotify-internal/encore-web';
import {
  AuthScreen,
  useFormFieldsContext,
} from '@spotify/confidence-core-react';

import { type SurveyFormValues, isRoleAnswered } from './surveyForm';

import styles from './OnboardingSurvey.module.css';

type SurveyActionsProps = {
  isSaving: boolean;
  onSkip: () => void;
};

export const SurveyActions = ({ isSaving, onSkip }: SurveyActionsProps) => {
  const { values } = useFormFieldsContext<SurveyFormValues>();
  const canSubmit = isRoleAnswered(values);

  return (
    <AuthScreen.Actions className={styles.actions}>
      <Button
        type="submit"
        variant="primary"
        colorSet="inverted"
        size="medium"
        isLoading={isSaving}
        loadingAriaLabel="Saving"
        disabled={!canSubmit || isSaving}
       data-track-source-anchor="14d2c0b5d6;;high">
        Submit
      </Button>
      <Button
        type="button"
        variant="tertiary"
        size="medium"
        disabled={isSaving}
        onClick={onSkip}
       data-track-source-anchor="51e6f04281">
        Skip
      </Button>
    </AuthScreen.Actions>
  );
};
